var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import * as moment from 'moment';
import { NodeElement } from './base/node-element';
import { DiagramConsts } from '../diagram-consts';
import { DatetimeSeparatorType } from '@flexem/fc-gui/model/datetime-display/datetime-separator-type';
import { DateFormatType } from '@flexem/fc-gui/model/datetime-display/date-format-type';
import { TimeFormatType } from '@flexem/fc-gui/model/datetime-display/time-format-type';
import { GraphService } from '../../../../shared/gallery/graph.service';
var DateTimeElement = /** @class */ (function (_super) {
    __extends(DateTimeElement, _super);
    function DateTimeElement(injector) {
        var _this = _super.call(this, injector) || this;
        _this.graphService = injector.get(GraphService);
        return _this;
    }
    DateTimeElement.prototype.compile = function (model, data, svg) {
        model['version'] = 4;
        model['angle'] = data.angle;
        model['showDate'] = data.showDate;
        model['dateFormat'] = data.dateFormat;
        model['datetimeSeparator'] = data.datetimeSeparator;
        model['showFullYear'] = data.showFullYear;
        model['showMonthDayWithoutZero'] = data.showMonthDayWithoutZero;
        model['showWeek'] = data.showWeek;
        model['showTime'] = data.showTime;
        model['timeFormat'] = data.timeFormat;
        model['isTwelveHourHex'] = data.isTwelveHourHex;
        model['size'] = this.sizeService.parse(data.size);
        model['useGraph'] = data.useGraph;
        model['graphSetting'] = data.graphSetting;
        // 清除编辑器的虚线及下划线
        svg.find('path').remove();
        svg.find('image').remove();
        if (data.isUnderline) {
            svg.find('text').attr('text-decoration', 'underline ');
        }
    };
    DateTimeElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/date-time.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    DateTimeElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Auto', {
            rotatable: true,
            locationObjectName: 'SHAPE', locationSpot: go.Spot.TopLeft, resizable: true,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('rotatable', 'locked', function (locked) { return !locked; }), new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), $(go.Shape, { fill: 'transparent', stroke: 'gray', strokeWidth: 0.5, strokeDashArray: [4, 4] }, new go.Binding('visible', 'useGraph', function (useGraph) { return !useGraph; })), $(go.Panel, go.Panel.Spot, $(go.Picture, { name: 'IMAGE' }, { sourceCrossOrigin: function (__) { return 'anonymous'; } }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('source', 'graphSetting', function (setting, __) { return _this.graphService.getCustomStyleGraphUrl(setting); }), new go.Binding('visible', 'useGraph')), $(go.TextBlock, {
            alignment: go.Spot.Center,
            minSize: new go.Size(40, 10),
            font: '16px Microsoft Yahei,msyh',
            margin: 10,
            editable: false,
            verticalAlignment: go.Spot.Center,
            wrap: go.TextBlock.None
        }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('textAlign').makeTwoWay(), new go.Binding('text', '', function (data) {
            var timeFormat = '';
            // 显示4位年份
            var yearFormat = data.showFullYear ? 'YYYY' : 'YY';
            // 分隔符
            var seperator = '';
            // 日月清零
            var monthFormat = data.showMonthDayWithoutZero ? 'M' : 'MM';
            var dayFormat = data.showMonthDayWithoutZero ? 'D' : 'DD';
            if (data.showDate) {
                switch (data.datetimeSeparator) {
                    case DatetimeSeparatorType.Slash:
                        seperator = '/';
                        break;
                    case DatetimeSeparatorType.Line:
                        seperator = '-';
                        break;
                    case DatetimeSeparatorType.Dot:
                        seperator = '.';
                        break;
                    case DatetimeSeparatorType.CHS:
                        // 年月日格式在构造时候处理
                        break;
                }
                timeFormat = _this.getDateTimeFormat(data.dateFormat, yearFormat, monthFormat, dayFormat, seperator);
            }
            if (data.showWeek) {
                timeFormat += ' ddd';
            }
            if (data.showTime) {
                if (data.isTwelveHourHex) {
                    timeFormat += ' A';
                    switch (data.timeFormat) {
                        case TimeFormatType.HHMMSS:
                            timeFormat += ' h:mm:ss';
                            break;
                        case TimeFormatType.HHMM:
                            timeFormat += ' h:mm';
                            break;
                    }
                }
                else {
                    switch (data.timeFormat) {
                        case TimeFormatType.HHMMSS:
                            timeFormat += ' HH:mm:ss';
                            break;
                        case TimeFormatType.HHMM:
                            timeFormat += ' HH:mm';
                            break;
                    }
                }
            }
            if (!data.showDate && !data.showWeek && !data.showTime) {
                return null;
            }
            return moment().local().format(timeFormat);
        }), new go.Binding('font', 'font', function (font) {
            return font + ', msyh';
        }), new go.Binding('isUnderline').makeTwoWay(), new go.Binding('stroke').makeTwoWay())));
    };
    DateTimeElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.dateTimeKey;
    };
    DateTimeElement.prototype.getDateTimeFormat = function (dateFormatType, yearFormat, monthFormat, dayFormat, seperator) {
        var yearSeperator = '年';
        var monthSeperator = '月';
        var daySeperator = '日';
        var dateFormat = '';
        if (seperator === '') {
            switch (dateFormatType) {
                case DateFormatType.YYMMDD:
                    dateFormat = yearFormat + yearSeperator + monthFormat + monthSeperator + dayFormat + daySeperator;
                    break;
                case DateFormatType.MMDDYY:
                    dateFormat = monthFormat + monthSeperator + dayFormat + daySeperator + yearFormat + yearSeperator;
                    break;
                case DateFormatType.DDMMYY:
                    dateFormat = dayFormat + daySeperator + monthFormat + monthSeperator + yearFormat + yearSeperator;
                    break;
            }
        }
        else {
            switch (dateFormatType) {
                case DateFormatType.YYMMDD:
                    dateFormat = yearFormat + seperator + monthFormat + seperator + dayFormat;
                    break;
                case DateFormatType.MMDDYY:
                    dateFormat = monthFormat + seperator + dayFormat + seperator + yearFormat;
                    break;
                case DateFormatType.DDMMYY:
                    dateFormat = dayFormat + seperator + monthFormat + seperator + yearFormat;
                    break;
            }
        }
        return dateFormat;
    };
    return DateTimeElement;
}(NodeElement));
export { DateTimeElement };
